<i18n src="./translations"></i18n>

<template>
  <div
    class="productImageSlider"
    :class="{ 'product-image-slider--product-page': isProductPage }"
  >
    <Slider
      class="main-slider"
      :items="items"
      @click-image="openLayer"
      @change-image="onChangeSliderImage"
    />

    <Dialog ref="productImageDialog" :click-outside="true" :title="title">
      <Slider ref="productImageDialogSlider" :items="items" />
    </Dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Slider from 'Components/02-molecules/slider/Slider';
import Dialog from 'Components/02-molecules/dialog/Dialog';

export default {
  name: 'ProductImageSlider',
  components: { Slider, Dialog },
  props: {
    title: {
      type: String,
      default: '',
    },
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentSliderImage: 1,
    };
  },
  computed: {
    ...mapGetters('core', ['isProductPage']),
    items() {
      let images = [];

      if (this.images && this.images.length) {
        images = this.images.map((image) => {
          return {
            full: {
              component: 'ProductImageItem',
              product: image,
            },
            thumbnail: {
              component: 'ProductImageThumbnail',
              image,
            },
          };
        });
      } else {
        images = [
          {
            full: {
              component: 'NoImageSvg',
              width: 270,
              height: 400,
              'data-testid': 'pdp-noImagePlaceholder',
              // TODO: Add Lazy
            },
            thumbnail: {
              component: 'ProductImageThumbnail',
              image: {
                src: '',
              },
            },
          },
        ];
      }

      return images;
    },
  },
  methods: {
    onChangeSliderImage(nextImage) {
      this.currentSliderImage = nextImage;
    },
    async openLayer() {
      this.$refs.productImageDialog.show();
      await this.$nextTick();
      this.$refs.productImageDialogSlider.goto(this.currentSliderImage);
    },
  },
};
</script>

<style scoped lang="scss">
.main-slider {
  --cursor: zoom-in;
  --slider-image-height: 327px;
}

.product-image-slider--product-page {
  ::v-deep {
    .controlIcon {
      color: var(--color-secondary);
    }

    .thumbnail.active {
      border-color: var(--color-secondary);
    }
  }
}
</style>
